// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"57":"755d09ce","468":"4c32a3b6","836":"cb242eb9"}[chunkId] + ".chunk.css";
};